import { render, staticRenderFns } from "./ConnectionSupportSection.vue?vue&type=template&id=882360b4&scoped=true"
import script from "./ConnectionSupportSection.vue?vue&type=script&lang=js"
export * from "./ConnectionSupportSection.vue?vue&type=script&lang=js"
import style0 from "./ConnectionSupportSection.vue?vue&type=style&index=0&id=882360b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882360b4",
  null
  
)

export default component.exports